import { createCrudPage } from './factories/crud-page.js';

const basePath = '/videos';

export default createCrudPage({
  title: 'Videos',
  basePath,
  columns: [
    { key: 'title', label: 'Title', sortable: true },
    { key: 'link', label: 'Link', sortable: true },
    { key: 'publication_date', label: 'Publication', sortable: true },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'publication_date', label: 'Publication', type: 'datetime' },
    { key: 'intro', label: 'Intro', type: 'textarea' },
    { key: 'link', label: 'Link', type: 'text',
      fieldInfo: 'Insert link to YouTube video. (Click share on YouTube, copy link and paste it here)' },
    { key: 'screenshot', label: 'Screen shot', type: 'file', accept: 'image/*', photo: true,
      fieldInfo: 'This photo will be loaded first, before video starts. Recommended proportion is 16:9' },
    { key: 'sector', label: 'Sector', type: 'async-select',
      optionsUrl: '/company-types/options',
      placeholder: 'Select sector' },
    { key: 'active', label: 'Active', type: 'yesno', defaultValue: '0' },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'activate', label: 'Activate', icon: 'activate',
      confirm: 'Are you sure you want to activate this video?',
      visible: (row) => row.active == 0 },
    { key: 'deactivate', label: 'Deactivate', icon: 'deactivate',
      confirm: 'Are you sure you want to deactivate this video?',
      visible: (row) => row.active == 1 },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  customActions: (ctx) => ({
    activate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { active: 1 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    deactivate: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { active: 0 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
  }),
  defaultSort: { field: 'publication_date', dir: 'desc' },
});
